import { Link, useLocation } from "react-router-dom";
import { HiHome, HiTruck, HiDocumentDuplicate } from "react-icons/hi";

type SidebarProps = {
  isCollapsed: boolean;
};

const LoadingSidebar: React.FC<SidebarProps> = ({ isCollapsed }) => {
  const location = useLocation();

  const menu = [
    { icon: <HiHome />, name: "Dashboard", path: "/loading/dashboard" },
    { icon: <HiTruck />, name: "Shipments", path: "/loading/shipments" },
    { icon: <HiDocumentDuplicate />, name: "Reports", path: "/loading/reports" },
  ];

  return (
    <aside
      className={`h-screen bg-white dark:bg-slate-800 text-slate-900 dark:text-white transition-[width] duration-300 ease-in-out ${
        isCollapsed ? "w-16" : "w-64"
      }`}
    >
      <div className="flex items-center justify-center h-14 border-b border-white dark:border-slate-800 px-2">
        <div className="flex items-center gap-2">
          <h2
            className={`text-lg font-bold text-primary transition-all origin-left duration-300 ${
              isCollapsed
                ? "opacity-0 scale-95 w-0 overflow-hidden"
                : "opacity-100 scale-100 w-auto"
            }`}
          >
            🚚 Loading Panel
          </h2>
          {isCollapsed && <span className="text-xl">🚚</span>}
        </div>
      </div>

      <nav className="flex flex-col gap-2 py-2">
        {menu.map((item, i) => {
          const isActive = location.pathname === item.path;

          return (
            <Link
              to={item.path}
              key={i}
              className={`flex items-center gap-4 px-4 h-12 text-sm font-medium transition-colors ${
                isActive
                  ? "bg-slate-100 text-primary dark:bg-slate-800 dark:text-white"
                  : "text-slate-700 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800"
              }`}
            >
              <span className="text-xl">{item.icon}</span>
              {!isCollapsed && <span>{item.name}</span>}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
};

export default LoadingSidebar;
